import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ConfigurationLoadingProps {
  title?: string;
  description?: string;
}

export function ConfigurationLoading({ 
  title,
  description
}: ConfigurationLoadingProps) {
  const { t } = useTranslation('business', { keyPrefix: 'communication' });
  const defaultTitle = t('loadingConfiguration');
  const defaultDescription = t('preparingChatbotSettings');
  
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6">
      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-500 to-purple-600 flex items-center justify-center mb-4">
        <Loader2 className="w-6 h-6 text-white animate-spin" />
      </div>
      <h3 className="text-lg font-semibold text-slate-900 mb-2">{title || defaultTitle}</h3>
      <p className="text-slate-600 text-center max-w-sm">
        {description || defaultDescription}
      </p>
    </div>
  );
} 